$(document).ready(function($) {
  //
  // Tabs Toggler
  //
  
  ( function( $ ) {
  	// Variables
  	const $tabLink = $( '#tabs-section .tab-link' );
  	const $tabBody = $( '#tabs-section .tab-body' );
  	let timerOpacity;
  
  	// Toggle Class
  	const init = () => {
  		// Menu Click
  		$tabLink.off( 'click' ).on( 'click', function( e ) {
  			// Prevent Default
  			e.preventDefault();
  			e.stopPropagation();
  
  			// Clear Timers
  			window.clearTimeout( timerOpacity );
  
  			// Toggle Class Logic
  			// Remove Active Classes
  			$tabLink.removeClass( 'active ' );
  			$tabBody.removeClass( 'active ' );
  			$tabBody.removeClass( 'active-content' );
  
  			// Add Active Classes
  			$( this ).addClass( 'active' );
  			$( $( this ).attr( 'href' ) ).addClass( 'active' );
  
  			// Opacity Transition Class
  			timerOpacity = setTimeout( () => {
  				$( $( this ).attr( 'href' ) ).addClass( 'active-content' );
  			}, 50 );
  		} );
        $(".tab-body h4").click(function(){
          if($(this).closest(".tab-body").find(".tab-body-content").is(':visible')){
              $(this).closest(".tab-body").find(".tab-body-content").slideDown();
          } else {
              $(this).closest(".tab-body").find(".tab-body-content").slideUp();
          }
          $(this).closest(".tab-body").siblings().find(".tab-body-content").stop(true,true).slideUp();
          $(this).closest(".tab-body").find(".tab-body-content").stop(true,true).slideToggle();
          $(this).closest(".tab-body").siblings().removeClass('open');
          $(this).closest(".tab-body").toggleClass('open');
      });
  	};
  
  	// Document Ready
  	$( function() {
  		init();
  	} );
  }( jQuery ) );
});